// eslint-disable-next-line @nx/enforce-module-boundaries
import { environment } from 'libs/frontend/environments/src/environment';

import { EnvironmentService } from '@bp/frontend/services/environment';
import {
	MockedBackendState, LocalBackendState, ConsoleLoggingState, End2EndTestRunState
} from '@bp/frontend/services/persistent-state-keepers';
import { TelemetryService } from '@bp/frontend/services/telemetry';

/**
 * Logic that should be kicked in before execution of any app module file
 */
EnvironmentService.init(environment);

if (End2EndTestRunState.isTestRunUserAgent(navigator.userAgent))
	End2EndTestRunState.set(true);

if (environment.name === 'local' || MockedBackendState.isActive || LocalBackendState.isActive || End2EndTestRunState.isActive)
	ConsoleLoggingState.set(true);

/**
 * `isHumanManaged` is `!isbot(userAgent)`, and the e2e suite's own user agent reads as a bot —
 * so a test run used to leave telemetry uninitialised and report nothing at all. That was
 * incidental rather than chosen, and it is the runs we can least afford to be blind on.
 *
 * LogRocket still opts out of e2e on its own, so this brings up Sentry and leaves the session
 * recording off.
 */
if ((EnvironmentService.isHumanManaged || End2EndTestRunState.isActive) && !LocalBackendState.isActive)
	TelemetryService.init(environment);

TelemetryService.log('Environment has been setup');
